import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const workOderReportColumns: GridColumnConfig[] = [
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Jobsite',
    field: 'jobsite',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Builder Job Number',
    field: 'jobNumber',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Work Order Number',
    field: 'workOrderNumber',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  {
    title: 'Expected Time (Minutes)',
    field: 'expectedTime',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  // {
  //   title: 'Service Code',
  //   field: 'serviceCode',
  //   filter: 'text',
  //   width: '200',
  //   searchable: true,
  // },
 {
    title: 'Primary Inspector',
    field: 'inspectorName',
    filter: 'text',
    width: '180',
    searchable: true,
  },
    {
    title: 'Secondary Inspector',
    field: 'secondaryInspectorName',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'workOrderStatus',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Created On',
    field: 'workorderCreatedOn',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Status Updated On',
    field: 'workOrderLastStatusUpdatedOn',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  // {
  //   title: 'Proposed Scheduled Date',
  //   field: 'proposedScheduledDate',
  //   filter: 'text',
  //   width: '220',
  //   searchable: true,
  // },
  {
    title: 'Scheduled Date',
    field: 'scheduledDate',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Completed On',
    field: 'completedOn',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Inspection Completed Date',
    field: 'ffInspectionCompletedOn',
    filter: 'text',
    width: '210',
    searchable: true,
  },
  // {
  //   title: 'Waived On',
  //   field: 'waivedOn',
  //   filter: 'text',
  //   width: '220',
  //   searchable: true,
  // },
  // {
  //   title: 'Canceled On',
  //   field: 'canceledOn',
  //   filter: 'text',
  //   width: '220',
  //   searchable: true,
  // },
  // {
  //   title: 'Price ($)',
  //   field: 'price',
  //   filter: 'text',
  //   fieldType: 'currency',
  //   width: '180',
  //   searchable: true,
  // },
  {
    title: 'Price ($)',
    field: 'priceNumeric',
    // fieldType: 'currency',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  {
    title: 'Invoice #',
    field: 'invoiceNo',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  // {
  //   title: 'Invoice Amount ($)',
  //   field: 'invoiceAmount',
  //   filter: 'text',
  //   fieldType: 'currency',
  //   width: '180',
  //   searchable: true,
  // },
  {
    title: 'Invoice Amount ($)',
    field: 'invoiceAmountNumeric',
    // fieldType: 'currency',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  // {
  //   title: 'Accrual Amount ($)',
  //   field: 'accrualAmount',
  //   filter: 'text',
  //   fieldType: 'currency',
  //   width: '180',
  //   searchable: true,
  // }
  {
    title: 'Accrual Amount ($)',
    field: 'accrualAmountNumeric',
    // fieldType: 'currency',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  {
    title: 'Market Area',
    field: 'marketAreas',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Project Department',
    field: 'projectDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Lot Department',
    field: 'unitDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Active/Inactive Work Order Status',
    field: 'workOrderActiveStatus',
    filter: 'text',
    width: '250',
    searchable: true,
  }
];
